import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const moduleService = {
    getAllModules,
    storeModule
}

function getAllModules(id) {
    if (id !== undefined) {
        return SC.getCall(`getAllModules/${pathSegment(id)}`);
    }
    return SC.getCall('getAllModules');
}

function storeModule(module) {
    return SC.postCall('modules', module);
}
